import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_POSTS } from "../graphql/GET_POSTS";
import "./blog.css";
import { Link } from "react-router-dom";

const FallbackCardImg =
  "https://snasso.quintbrothers.com/wp-content/uploads/2025/09/defulat-image-scaled.webp";
const PAGE_SIZE = 6;

export default function BlogBusiness() {
  const [after, setAfter] = useState(null);

  const { data, loading, error, fetchMore } = useQuery(GET_POSTS, {
    variables: { first: PAGE_SIZE, after: null },
    notifyOnNetworkStatusChange: true,
  });

  const nodes = data?.posts?.nodes ?? [];
  const pageInfo = data?.posts?.pageInfo;

  const loadMore = () => {
    if (!pageInfo?.hasNextPage) return;
    fetchMore({
      variables: { first: PAGE_SIZE, after: pageInfo.endCursor },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          posts: {
            ...fetchMoreResult.posts,
            nodes: [...prev.posts.nodes, ...fetchMoreResult.posts.nodes],
          },
        };
      },
    });
    setAfter(pageInfo.endCursor);
  };

  return (
    <div className="blog-container">
      <h1>News & Blog</h1>
      <h2 className="latest-articles">
        Updates From <span>Reveal</span>
      </h2>

      {error && <p className="error">Failed to load posts. {error.message}</p>}

      <div className="blogs">
        {nodes.map((post) => {
          const img = post?.featuredImage?.node?.sourceUrl ?? FallbackCardImg;
          const alt =
            post?.featuredImage?.node?.altText || post.title || "Post image";
          const author = post?.author?.node?.name || "Admin";
          const date = post?.date
            ? new Date(post.date).toLocaleDateString()
            : "";
          const tags = post?.tags?.nodes ?? [];

          return (
            <article key={post.id} className="blog-card">
              <Link
                to={`/blog/${post.slug}`}
                className="card-link"
                aria-label={`Read: ${post.title}`}
              >
                <div className="blog-thumbnail">
                  <img src={img} alt={alt} loading="lazy" />
                </div>
                <div className="blog-content">
                  <span className="author">
                    By {author} {date ? `• ${date}` : ""}
                  </span>
                  <h3 className="blog-title">{post.title}</h3>
                  <p
                    className="summary"
                    dangerouslySetInnerHTML={{ __html: post.excerpt }}
                  />
                  <div className="blog-meta">
                    <span className="tags">
                      {tags.map((t) => (
                        <span key={t.id} className="tag">
                          {t.name}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          );
        })}
      </div>

      <div className="blog-pagination">
        {pageInfo?.hasNextPage && (
          <button onClick={loadMore} disabled={loading} className="load-more">
            {loading ? "Loading…" : "Load more"}
          </button>
        )}
      </div>
    </div>
  );
}
